
























import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import IconButton from '@/modules/shared/shared/components/TooltipButton.vue';

@Component({
    name: 'base-modal',
    components: { IconButton },
})
export default class BaseModal extends Vue {
    @Prop({ default: 400, required: false })
    maxWith!: number;

    @Prop({ type: Boolean, default: false, required: false })
    persistent!: boolean;

    @Prop({ type: String, default: () => '', required: false })
    title!: string;

    @Prop({ type: String, default: () => '', required: false })
    icon!: string;

    public show: boolean = false;

    public openModal() {
        this.show = true;
    }

    public closeModal() {
        this.show = false;
    }

    public get isOpened(): boolean {
        return this.show;
    }
}
